import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../generic/serialization/serializable-object-schema';
import { CommunicationTask } from '../../generic/communication-task/communication-task';
import { CommunicationTaskSchema } from '../../generic/communication-task/communication-task-schema';
import { CommunicationTaskName } from '../../generic/communication-task-name';

import { CommunicationTaskCallbackRequestConstructor } from './communication-task-callback-request-constructor';
import { CommunicationTaskCallbackRequestSchema } from './communication-task-callback-request-schema';

export class CommunicationTaskCallbackRequest extends CommunicationTask {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected serviceableAddressId!: string;

  protected asyncServiceRequestId!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationTaskCallbackRequestConstructor) {
    (parameters as any)[CommunicationTaskSchema.type] = CommunicationTaskName.callbackRequest;
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): CommunicationTaskCallbackRequest {
    return new CommunicationTaskCallbackRequest(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationTaskCallbackRequest.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationTaskCallbackRequestSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getServiceableAddressId(): string {
    return cloneDeep(this.serviceableAddressId);
  }

  public getAsyncServiceRequestId(): string {
    return cloneDeep(this.asyncServiceRequestId);
  }
}
